import { redirectDocument } from 'react-router-dom'

import { getAppUrl } from '@/config/marketing-nav.config'

export function loginRedirectLoader() {
  return redirectDocument(getAppUrl('/login'))
}
